module.exports = __webpack_public_path__ + "static/media/menu1_cont_05.7fa72260.png";